<template>
  <span class="inline-flex min-w-0 items-center gap-1.5">
    <span class="truncate font-mono" :title="revealed ? value || undefined : undefined">
      {{ revealed ? value : maskTokenValue(value) }}
    </span>

    <!-- Opt-in: most rows and cards holding this value are clickable, and a button
         inside a link is invalid markup. Where it is offered, the toggle must not
         trigger the row navigation. -->
    <button
      v-if="value && revealable"
      type="button"
      :aria-label="revealed ? t('hide') : t('reveal')"
      :aria-pressed="revealed"
      class="shrink-0 p-0.5 text-neutral-400 transition-colors duration-150 ease-out-quart hover:text-neutral-600"
      @click.stop.prevent="revealed = !revealed"
    >
      <font-awesome-icon :icon="['fal', revealed ? 'eye-slash' : 'eye']" fixed-width />
    </button>
  </span>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { maskTokenValue } from '@infuse/ui/utils';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

withDefaults(defineProps<{ value?: string | null; revealable?: boolean }>(), { value: undefined, revealable: false });

const { t } = useI18n();

const revealed = ref(false);
</script>

<i18n>
{
  "en": {
    "hide": "Hide value",
    "reveal": "Show value"
  },
  "nl": {
    "hide": "Waarde verbergen",
    "reveal": "Waarde weergeven"
  }
}
</i18n>
